import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import { startRequest as loadMessageCounter } from '../../Messages/redux/messageCounter/actions';
import Header from '../components/Header';
import { getAvatar } from '../redux/avatar/actions';
import { getLkIp } from '../redux/lkIp/actions';
import { handlerSearch } from '../redux/serachOverlay/actions';
import { selectAvatar, selectLkIp, selectShowSearch, selectUser } from '../utils/selectors';
import { closeWriteOffMessage } from '../redux/user/actions';
import { selectMessageCounter } from '../../Messages/utils/selectors';

const mapStateToProps = (state) => ({
  user: selectUser(state),
  avatar: selectAvatar(state),
  messageCounter: selectMessageCounter(state),
  lkIp: selectLkIp(state),
  showSearch: selectShowSearch(state),
});

const mapDispatchToProps = (dispatch) =>
  bindActionCreators(
    {
      getLkIp,
      getAvatar,
      handlerSearch,
      closeWriteOffMessage,
      loadMessageCounter,
    },
    dispatch,
  );

export default connect(mapStateToProps, mapDispatchToProps)(Header);
